import React from "react";
import PropTypes from "prop-types";
import StackedPromotionRow from "./StackedPromotionRow";
import DiscountPopover from "./DiscountPopover";
import { getDiscountValueFromRule } from "../../constants/utils";

// A bounded section holding one legacy (rule-based) promo as a flat row.
const StackedLegacyPromoGroup = ({ promo, rule, dayOfWeek, currency }) => {
  const discountValue = getDiscountValueFromRule(rule, currency, dayOfWeek);
  return (
    <div className="stacked-promotions__group">
      <StackedPromotionRow
        name={promo.ruleName}
        discountValue={discountValue}
        popover={
          <DiscountPopover
            rule={rule}
            promo={promo}
            discountValue={discountValue}
            dayOfWeek={dayOfWeek}
          />
        }
      />
    </div>
  );
};

StackedLegacyPromoGroup.propTypes = {
  promo: PropTypes.shape({
    id: PropTypes.number,
    ruleName: PropTypes.string,
  }).isRequired,
  rule: PropTypes.object,
  dayOfWeek: PropTypes.number,
  currency: PropTypes.string,
};

export default StackedLegacyPromoGroup;
